module.exports = __webpack_public_path__ + "img/cuba.49de433f.svg";